import { useEffect, useState } from "react";
import { useModalState } from "clientState/AuthFlow/providers/ModalScreenProvider";

export const useLandingPagePath = (): string => {
  const [landingPagePath, setLandingPagePath] = useState("");
  const { emailLinkPath } = useModalState();

  useEffect(() => {
    if (emailLinkPath) {
      setLandingPagePath(emailLinkPath);
    } else {
      const { pathname, hash } = new URL(window.location.href);
      setLandingPagePath(pathname + hash);
    }
  }, [emailLinkPath]);

  return landingPagePath;
};
